/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A single day's Shadow-MCP-observed call count for an unproxied MCP server
 */
export type UnproxiedMcpServerUsageBucket = {
  /**
   * Number of observed tool calls in this bucket
   */
  callCount: number;
  /**
   * Bucket date (YYYY-MM-DD, UTC)
   */
  date: string;
};

/** @internal */
export const UnproxiedMcpServerUsageBucket$inboundSchema: z.ZodMiniType<
  UnproxiedMcpServerUsageBucket,
  unknown
> = z.pipe(
  z.object({
    call_count: z.int(),
    date: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "call_count": "callCount",
    });
  }),
);

export function unproxiedMcpServerUsageBucketFromJSON(
  jsonString: string,
): SafeParseResult<UnproxiedMcpServerUsageBucket, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UnproxiedMcpServerUsageBucket$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UnproxiedMcpServerUsageBucket' from JSON`,
  );
}
